import React from 'react'

const ThreeBHKInteriorDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-three-bhk-interior-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    3BHK Interior Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us.html" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us.html" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="imgs/three-bhk-interior-design.jpg" alt="" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      A 3 BHK home offers the perfect canvas for creating stylish,
                      spacious, and personalized interiors. At MeHome, with 15+ years
                      of expertise in interior design and construction, we specialize
                      in transforming 3 BHK apartments and villas into elegant homes
                      that blend luxury, comfort, and functionality.
                    </p>
                    <p className="wow fadeInUp">
                      Whether you want a modern, minimalist, or luxury setup, our team
                      ensures every room in your 3 BHK reflects your personality and
                      meets your lifestyle needs.
                    </p>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Why 3 BHK Homes Deserve <span> Exclusive Design </span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      A 3 BHK gives you ample space and flexibility, but without
                      thoughtful design, it may feel unbalanced or underutilized.
                      That’s where MeHome makes the difference:
                    </p>
                    <ul>
                      <li>Space Harmony: Coordinated layouts that create flow and balance between rooms.</li>
                      <li>Customized Themes: Each bedroom or living space can have its unique theme, yet complement the overall design.</li>
                      <li>Smart Functionality: Designs that optimize comfort, practicality, and luxury at the same time.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our 3BHK <span> Interior Design Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🛋️</div>
                        <div className="why-choose-item-content">
                          <h3>Living Room</h3>
                          <p>
                            Grand living spaces with stylish TV units, modern false
                            ceilings, elegant lighting, and spacious seating
                            arrangements—perfect for family gatherings and guest
                            entertainment.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🛏️</div>
                        <div className="why-choose-item-content">
                          <h3>Bedroom</h3>
                          <p>
                            Each bedroom is a personal retreat—whether it’s a master
                            bedroom with walk-in wardrobes, a kid’s room with playful
                            interiors, or a guest room with cozy finishes.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🍳</div>
                        <div className="why-choose-item-content">
                          <h3>Modular Kitchen</h3>
                          <p>
                            Spacious, well-planned kitchens with ample storage,
                            premium fittings, and ergonomic layouts for everyday
                            convenience. Options include U-shaped, L-shaped, or island
                            kitchens based on your preference.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🚿</div>
                        <div className="why-choose-item-content">
                          <h3>Bathrooms</h3>
                          <p>
                            Luxurious bathrooms with modern sanitary fittings,
                            vanities, mood lighting, and designer tiles for a premium
                            experience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🪑</div>
                        <div className="why-choose-item-content">
                          <h3>Dining Area</h3>
                          <p>
                            Dedicated dining areas with elegant décor, functional
                            storage, and lighting that enhances family mealtime
                            experiences.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🌿</div>
                        <div className="why-choose-item-content">
                          <h3>Balconies and Extra Spaces</h3>
                          <p>
                            Transform balconies, study rooms, or home offices into
                            functional lifestyle zones—like reading corners, mini
                            lounges, or green spaces.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why MeHome is Perfect for <span>3BHK Interior Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>15+ Years of Industry Experience </b>– Trusted by hundreds of happy homeowners.</li>
                        <li><b>Compact Space Experts </b>– Specialized designs for small apartments.</li>
                        <li><b>End-to-End Services </b>– From planning, 3D visualization, and construction to finishing.</li>
                        <li><b>Affordable Luxury </b> – Premium interiors designed within your budget.</li>
                        <li><b>On-Time Execution </b>– Hassle-free project delivery, every time.</li>
                        <li><b>Quality Craftsmanship </b> – Durable materials and flawless workmanship.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="service-sidebar">
                  <div className="service-catagery-list wow fadeInUp">
                    <h3>Interior Design</h3>
                    <ul>
                      <li><a className="nav-link" href="kitchen-designs.html">Kitchen Designs</a></li>
                      <li><a className="nav-link" href="bedroom-designs.html">Bedroom Designs</a></li>
                      <li><a className="nav-link" href="dining-room-designs.html">Dining Room Designs</a></li>
                      <li><a className="nav-link" href="living-room-designs.html">Living Room Designs</a></li>
                      <li><a className="nav-link" href="decorative-units-designs.html">Decorative Units Designs</a></li>
                      <li><a className="nav-link" href="kids-room-designs.html">Kids Room Designs</a></li>
                    </ul>
                  </div>

                  <div className="service-catagery-list wow fadeInUp">
                    <h3>Explore Designs</h3>
                    <ul>
                      <li><a className="nav-link" href="one-bhk-interior-designs.html">1 BHK Interior Designs</a></li>
                      <li><a className="nav-link" href="two-bhkinterior-designs.html">2 BHK Interior Designs</a></li>
                      <li><a className="nav-link" href="three-bhk-interior-designs.html">3 BHK Interior Designs</a></li>
                    </ul>
                  </div>

                  <div className="service-catagery-list wow fadeInUp">
                    <h3>MeHome Ideas</h3>
                    <ul>
                      <li><a className="nav-link" href="outdoor-designs.html">Outdoor Designs</a></li>
                      <li><a className="nav-link" href="landscape-designs.html">Landscape Designs</a></li>
                      <li><a className="nav-link" href="furniture-designs.html">Furniture Designs</a></li>
                    </ul>
                  </div>

                  <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.2s">
                    <div className="sidebar-cta-image">
                      <div className="image-anime">
                        <img src="images/sidebar-cta-img.jpg" alt="" />
                      </div>
                    </div>

                    <div className="sidebar-cta-Body">
                      <div className="sidebar-cta-content">
                        <h3>how can we help</h3>
                        <p>If you need any helps, please feel free to contact us.</p>
                      </div>

                      <div className="sidebar-cta-contact">
                        <div className="sidebar-cta-contact-item">
                          <div className="icon-box">
                            <img src="images/icon-phone.svg" alt="" />
                          </div>
                          <div className="cta-contact-item-content">
                            <p>+91 1234567890</p>
                          </div>
                        </div>

                        <div className="sidebar-cta-contact-item">
                          <div className="icon-box">
                            <img src="images/icon-mail.svg" alt="" />
                          </div>
                          <div className="cta-contact-item-content">
                            <p>info@domain.com</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default ThreeBHKInteriorDesigns
